import type {ProfileComparisonVerdict, ProfileComparisonVerdictState} from '../../types/ProfileComparisonTypes';

export const getProfileComparisonVerdictState = (
  verdict: ProfileComparisonVerdict,
  profileAPublicId: string,
): ProfileComparisonVerdictState => {
  if (verdict.isTied) {
    return 'tied';
  }

  if (verdict.leadingProfileId === profileAPublicId) {
    return 'aLeads';
  }

  return 'bLeads';
};
